import { PropertyDocumentWalkingMinutesFromStationEnum } from 'src/api-client';

export const WALKING_MINUTES_FROM_STATION_OPTIONS = {
  [PropertyDocumentWalkingMinutesFromStationEnum.OneToFourMinutes]: '1~4分以内',
  [PropertyDocumentWalkingMinutesFromStationEnum.FiveToTenMinutes]: '5~10分以内',
  [PropertyDocumentWalkingMinutesFromStationEnum.ElevenToTwelveMinutes]: '11~12分以内',
  [PropertyDocumentWalkingMinutesFromStationEnum.MoreThanOrEqualToThirteenMinutes]: '13分以上',
};
